import { Query } from 'react-apollo'
import myLoans, { MyLoans, IFragmentBasicLoanFields } from '../../graphql/queries/myLoans'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class MyLoansQuery extends Query<MyLoans, {}> {}

const MyLoansQueryCompleted = withQuery(myLoans)(MyLoansQuery)

export type MyLoansQueryProps = GetProps<typeof MyLoansQueryCompleted>
export type MyLoansQueryResult = MyLoans
export type Loan = IFragmentBasicLoanFields

export default MyLoansQueryCompleted



// WEBPACK FOOTER //
// ./src/components/queries/MyLoansQuery.tsx